/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface AloCategory {
  event?:
    | { $case: "qualificationEvent"; qualificationEvent: AloCategory_AloQualificationEvent }
    | { $case: "handoffPageViewEvent"; handoffPageViewEvent: AloCategory_AloHandoffPageViewEvent }
    | { $case: "handoffSubmitEvent"; handoffSubmitEvent: AloCategory_AloHandoffSubmitEvent }
    | { $case: "pageViewEvent"; pageViewEvent: AloCategory_AloPageViewEvent }
    | undefined;
}

export enum AloCategory_QualificationDecision {
  UNKNOWN = 0,
  ELIGIBLE = 1,
  INELIGIBLE = 2,
  UNRECOGNIZED = -1,
}

export function aloCategory_QualificationDecisionFromJSON(object: any): AloCategory_QualificationDecision {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return AloCategory_QualificationDecision.UNKNOWN;
    case 1:
    case "ELIGIBLE":
      return AloCategory_QualificationDecision.ELIGIBLE;
    case 2:
    case "INELIGIBLE":
      return AloCategory_QualificationDecision.INELIGIBLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AloCategory_QualificationDecision.UNRECOGNIZED;
  }
}

export function aloCategory_QualificationDecisionToJSON(object: AloCategory_QualificationDecision): string {
  switch (object) {
    case AloCategory_QualificationDecision.UNKNOWN:
      return "UNKNOWN";
    case AloCategory_QualificationDecision.ELIGIBLE:
      return "ELIGIBLE";
    case AloCategory_QualificationDecision.INELIGIBLE:
      return "INELIGIBLE";
    case AloCategory_QualificationDecision.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AloCategory_ALOExperienceSlug {
  UNKNOWN_SLUG = 0,
  ALO_POST_HANDOFF_V1 = 1,
  UNRECOGNIZED = -1,
}

export function aloCategory_ALOExperienceSlugFromJSON(object: any): AloCategory_ALOExperienceSlug {
  switch (object) {
    case 0:
    case "UNKNOWN_SLUG":
      return AloCategory_ALOExperienceSlug.UNKNOWN_SLUG;
    case 1:
    case "ALO_POST_HANDOFF_V1":
      return AloCategory_ALOExperienceSlug.ALO_POST_HANDOFF_V1;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AloCategory_ALOExperienceSlug.UNRECOGNIZED;
  }
}

export function aloCategory_ALOExperienceSlugToJSON(object: AloCategory_ALOExperienceSlug): string {
  switch (object) {
    case AloCategory_ALOExperienceSlug.UNKNOWN_SLUG:
      return "UNKNOWN_SLUG";
    case AloCategory_ALOExperienceSlug.ALO_POST_HANDOFF_V1:
      return "ALO_POST_HANDOFF_V1";
    case AloCategory_ALOExperienceSlug.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Next ID: 10 */
export interface AloCategory_AloQualificationEvent {
  sellerInputUuid: string;
  leadUuid: string;
  offerUuid: string;
  flipToken: string;
  qualificationDecision: AloCategory_QualificationDecision;
  /** @deprecated */
  eligibilityDetails: { [key: string]: boolean };
  market: string;
  offerRequestSource: string;
  aloEligibilityDetails?: AloCategory_AloEligibilityDetails | undefined;
}

export interface AloCategory_AloQualificationEvent_EligibilityDetailsEntry {
  key: string;
  value: boolean;
}

/** Next ID: 10 */
export interface AloCategory_AloEligibilityDetails {
  isFirstOffer: boolean;
  isAfterLaunchDate: boolean;
  isEligibleMarket: boolean;
  isNotReit: boolean;
  isNotWorkingWithAgent: boolean;
  isNotRestrictedPartnershipLead: boolean;
  /** @deprecated */
  isNotPreviouslyDeniedRefresh: boolean;
  isValidOfferRequestSource: boolean;
  isNotVolumeRestricted: boolean;
}

/** Next ID: 4 */
export interface AloCategory_AloHandoffPageViewEvent {
  leadUuid: string;
  offerUuid: string;
  flipToken: string;
}

export interface AloCategory_AloPageViewEvent {
  leadUuid: string;
  offerUuid: string;
  flipToken: string;
  experienceSlug: AloCategory_ALOExperienceSlug;
}

/** Next ID: 7 */
export interface AloCategory_AloHandoffSubmitEvent {
  leadUuid: string;
  offerUuid: string;
  flipToken: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
}

function createBaseAloCategory(): AloCategory {
  return { event: undefined };
}

export const AloCategory = {
  fromJSON(object: any): AloCategory {
    return {
      event: isSet(object.qualificationEvent)
        ? {
          $case: "qualificationEvent",
          qualificationEvent: AloCategory_AloQualificationEvent.fromJSON(object.qualificationEvent),
        }
        : isSet(object.handoffPageViewEvent)
        ? {
          $case: "handoffPageViewEvent",
          handoffPageViewEvent: AloCategory_AloHandoffPageViewEvent.fromJSON(object.handoffPageViewEvent),
        }
        : isSet(object.handoffSubmitEvent)
        ? {
          $case: "handoffSubmitEvent",
          handoffSubmitEvent: AloCategory_AloHandoffSubmitEvent.fromJSON(object.handoffSubmitEvent),
        }
        : isSet(object.pageViewEvent)
        ? { $case: "pageViewEvent", pageViewEvent: AloCategory_AloPageViewEvent.fromJSON(object.pageViewEvent) }
        : undefined,
    };
  },

  toJSON(message: AloCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "qualificationEvent") {
      obj.qualificationEvent = AloCategory_AloQualificationEvent.toJSON(message.event.qualificationEvent);
    }
    if (message.event?.$case === "handoffPageViewEvent") {
      obj.handoffPageViewEvent = AloCategory_AloHandoffPageViewEvent.toJSON(message.event.handoffPageViewEvent);
    }
    if (message.event?.$case === "handoffSubmitEvent") {
      obj.handoffSubmitEvent = AloCategory_AloHandoffSubmitEvent.toJSON(message.event.handoffSubmitEvent);
    }
    if (message.event?.$case === "pageViewEvent") {
      obj.pageViewEvent = AloCategory_AloPageViewEvent.toJSON(message.event.pageViewEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory>, I>>(base?: I): AloCategory {
    return AloCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory>, I>>(object: I): AloCategory {
    const message = createBaseAloCategory();
    if (
      object.event?.$case === "qualificationEvent" &&
      object.event?.qualificationEvent !== undefined &&
      object.event?.qualificationEvent !== null
    ) {
      message.event = {
        $case: "qualificationEvent",
        qualificationEvent: AloCategory_AloQualificationEvent.fromPartial(object.event.qualificationEvent),
      };
    }
    if (
      object.event?.$case === "handoffPageViewEvent" &&
      object.event?.handoffPageViewEvent !== undefined &&
      object.event?.handoffPageViewEvent !== null
    ) {
      message.event = {
        $case: "handoffPageViewEvent",
        handoffPageViewEvent: AloCategory_AloHandoffPageViewEvent.fromPartial(object.event.handoffPageViewEvent),
      };
    }
    if (
      object.event?.$case === "handoffSubmitEvent" &&
      object.event?.handoffSubmitEvent !== undefined &&
      object.event?.handoffSubmitEvent !== null
    ) {
      message.event = {
        $case: "handoffSubmitEvent",
        handoffSubmitEvent: AloCategory_AloHandoffSubmitEvent.fromPartial(object.event.handoffSubmitEvent),
      };
    }
    if (
      object.event?.$case === "pageViewEvent" &&
      object.event?.pageViewEvent !== undefined &&
      object.event?.pageViewEvent !== null
    ) {
      message.event = {
        $case: "pageViewEvent",
        pageViewEvent: AloCategory_AloPageViewEvent.fromPartial(object.event.pageViewEvent),
      };
    }
    return message;
  },
};

function createBaseAloCategory_AloQualificationEvent(): AloCategory_AloQualificationEvent {
  return {
    sellerInputUuid: "",
    leadUuid: "",
    offerUuid: "",
    flipToken: "",
    qualificationDecision: 0,
    eligibilityDetails: {},
    market: "",
    offerRequestSource: "",
    aloEligibilityDetails: undefined,
  };
}

export const AloCategory_AloQualificationEvent = {
  fromJSON(object: any): AloCategory_AloQualificationEvent {
    return {
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
      leadUuid: isSet(object.leadUuid) ? String(object.leadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      flipToken: isSet(object.flipToken) ? String(object.flipToken) : "",
      qualificationDecision: isSet(object.qualificationDecision)
        ? aloCategory_QualificationDecisionFromJSON(object.qualificationDecision)
        : 0,
      eligibilityDetails: isObject(object.eligibilityDetails)
        ? Object.entries(object.eligibilityDetails).reduce<{ [key: string]: boolean }>((acc, [key, value]) => {
          acc[key] = Boolean(value);
          return acc;
        }, {})
        : {},
      market: isSet(object.market) ? String(object.market) : "",
      offerRequestSource: isSet(object.offerRequestSource) ? String(object.offerRequestSource) : "",
      aloEligibilityDetails: isSet(object.aloEligibilityDetails)
        ? AloCategory_AloEligibilityDetails.fromJSON(object.aloEligibilityDetails)
        : undefined,
    };
  },

  toJSON(message: AloCategory_AloQualificationEvent): unknown {
    const obj: any = {};
    if (message.sellerInputUuid !== "") {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.leadUuid !== "") {
      obj.leadUuid = message.leadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.flipToken !== "") {
      obj.flipToken = message.flipToken;
    }
    if (message.qualificationDecision !== 0) {
      obj.qualificationDecision = aloCategory_QualificationDecisionToJSON(message.qualificationDecision);
    }
    if (message.eligibilityDetails) {
      const entries = Object.entries(message.eligibilityDetails);
      if (entries.length > 0) {
        obj.eligibilityDetails = {};
        entries.forEach(([k, v]) => {
          obj.eligibilityDetails[k] = v;
        });
      }
    }
    if (message.market !== "") {
      obj.market = message.market;
    }
    if (message.offerRequestSource !== "") {
      obj.offerRequestSource = message.offerRequestSource;
    }
    if (message.aloEligibilityDetails !== undefined) {
      obj.aloEligibilityDetails = AloCategory_AloEligibilityDetails.toJSON(message.aloEligibilityDetails);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory_AloQualificationEvent>, I>>(
    base?: I,
  ): AloCategory_AloQualificationEvent {
    return AloCategory_AloQualificationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory_AloQualificationEvent>, I>>(
    object: I,
  ): AloCategory_AloQualificationEvent {
    const message = createBaseAloCategory_AloQualificationEvent();
    message.sellerInputUuid = object.sellerInputUuid ?? "";
    message.leadUuid = object.leadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.flipToken = object.flipToken ?? "";
    message.qualificationDecision = object.qualificationDecision ?? 0;
    message.eligibilityDetails = Object.entries(object.eligibilityDetails ?? {}).reduce<{ [key: string]: boolean }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.market = object.market ?? "";
    message.offerRequestSource = object.offerRequestSource ?? "";
    message.aloEligibilityDetails =
      (object.aloEligibilityDetails !== undefined && object.aloEligibilityDetails !== null)
        ? AloCategory_AloEligibilityDetails.fromPartial(object.aloEligibilityDetails)
        : undefined;
    return message;
  },
};

function createBaseAloCategory_AloQualificationEvent_EligibilityDetailsEntry(): AloCategory_AloQualificationEvent_EligibilityDetailsEntry {
  return { key: "", value: false };
}

export const AloCategory_AloQualificationEvent_EligibilityDetailsEntry = {
  fromJSON(object: any): AloCategory_AloQualificationEvent_EligibilityDetailsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? Boolean(object.value) : false,
    };
  },

  toJSON(message: AloCategory_AloQualificationEvent_EligibilityDetailsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value === true) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory_AloQualificationEvent_EligibilityDetailsEntry>, I>>(
    base?: I,
  ): AloCategory_AloQualificationEvent_EligibilityDetailsEntry {
    return AloCategory_AloQualificationEvent_EligibilityDetailsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory_AloQualificationEvent_EligibilityDetailsEntry>, I>>(
    object: I,
  ): AloCategory_AloQualificationEvent_EligibilityDetailsEntry {
    const message = createBaseAloCategory_AloQualificationEvent_EligibilityDetailsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseAloCategory_AloEligibilityDetails(): AloCategory_AloEligibilityDetails {
  return {
    isFirstOffer: false,
    isAfterLaunchDate: false,
    isEligibleMarket: false,
    isNotReit: false,
    isNotWorkingWithAgent: false,
    isNotRestrictedPartnershipLead: false,
    isNotPreviouslyDeniedRefresh: false,
    isValidOfferRequestSource: false,
    isNotVolumeRestricted: false,
  };
}

export const AloCategory_AloEligibilityDetails = {
  fromJSON(object: any): AloCategory_AloEligibilityDetails {
    return {
      isFirstOffer: isSet(object.is_first_offer) ? Boolean(object.is_first_offer) : false,
      isAfterLaunchDate: isSet(object.is_after_launch_date) ? Boolean(object.is_after_launch_date) : false,
      isEligibleMarket: isSet(object.is_eligible_market) ? Boolean(object.is_eligible_market) : false,
      isNotReit: isSet(object.is_not_reit) ? Boolean(object.is_not_reit) : false,
      isNotWorkingWithAgent: isSet(object.is_not_working_with_agent)
        ? Boolean(object.is_not_working_with_agent)
        : false,
      isNotRestrictedPartnershipLead: isSet(object.is_not_restricted_partnership_lead)
        ? Boolean(object.is_not_restricted_partnership_lead)
        : false,
      isNotPreviouslyDeniedRefresh: isSet(object.is_not_previously_denied_refresh)
        ? Boolean(object.is_not_previously_denied_refresh)
        : false,
      isValidOfferRequestSource: isSet(object.is_valid_offer_request_source)
        ? Boolean(object.is_valid_offer_request_source)
        : false,
      isNotVolumeRestricted: isSet(object.is_not_volume_restricted) ? Boolean(object.is_not_volume_restricted) : false,
    };
  },

  toJSON(message: AloCategory_AloEligibilityDetails): unknown {
    const obj: any = {};
    if (message.isFirstOffer === true) {
      obj.is_first_offer = message.isFirstOffer;
    }
    if (message.isAfterLaunchDate === true) {
      obj.is_after_launch_date = message.isAfterLaunchDate;
    }
    if (message.isEligibleMarket === true) {
      obj.is_eligible_market = message.isEligibleMarket;
    }
    if (message.isNotReit === true) {
      obj.is_not_reit = message.isNotReit;
    }
    if (message.isNotWorkingWithAgent === true) {
      obj.is_not_working_with_agent = message.isNotWorkingWithAgent;
    }
    if (message.isNotRestrictedPartnershipLead === true) {
      obj.is_not_restricted_partnership_lead = message.isNotRestrictedPartnershipLead;
    }
    if (message.isNotPreviouslyDeniedRefresh === true) {
      obj.is_not_previously_denied_refresh = message.isNotPreviouslyDeniedRefresh;
    }
    if (message.isValidOfferRequestSource === true) {
      obj.is_valid_offer_request_source = message.isValidOfferRequestSource;
    }
    if (message.isNotVolumeRestricted === true) {
      obj.is_not_volume_restricted = message.isNotVolumeRestricted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory_AloEligibilityDetails>, I>>(
    base?: I,
  ): AloCategory_AloEligibilityDetails {
    return AloCategory_AloEligibilityDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory_AloEligibilityDetails>, I>>(
    object: I,
  ): AloCategory_AloEligibilityDetails {
    const message = createBaseAloCategory_AloEligibilityDetails();
    message.isFirstOffer = object.isFirstOffer ?? false;
    message.isAfterLaunchDate = object.isAfterLaunchDate ?? false;
    message.isEligibleMarket = object.isEligibleMarket ?? false;
    message.isNotReit = object.isNotReit ?? false;
    message.isNotWorkingWithAgent = object.isNotWorkingWithAgent ?? false;
    message.isNotRestrictedPartnershipLead = object.isNotRestrictedPartnershipLead ?? false;
    message.isNotPreviouslyDeniedRefresh = object.isNotPreviouslyDeniedRefresh ?? false;
    message.isValidOfferRequestSource = object.isValidOfferRequestSource ?? false;
    message.isNotVolumeRestricted = object.isNotVolumeRestricted ?? false;
    return message;
  },
};

function createBaseAloCategory_AloHandoffPageViewEvent(): AloCategory_AloHandoffPageViewEvent {
  return { leadUuid: "", offerUuid: "", flipToken: "" };
}

export const AloCategory_AloHandoffPageViewEvent = {
  fromJSON(object: any): AloCategory_AloHandoffPageViewEvent {
    return {
      leadUuid: isSet(object.leadUuid) ? String(object.leadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      flipToken: isSet(object.flipToken) ? String(object.flipToken) : "",
    };
  },

  toJSON(message: AloCategory_AloHandoffPageViewEvent): unknown {
    const obj: any = {};
    if (message.leadUuid !== "") {
      obj.leadUuid = message.leadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.flipToken !== "") {
      obj.flipToken = message.flipToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory_AloHandoffPageViewEvent>, I>>(
    base?: I,
  ): AloCategory_AloHandoffPageViewEvent {
    return AloCategory_AloHandoffPageViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory_AloHandoffPageViewEvent>, I>>(
    object: I,
  ): AloCategory_AloHandoffPageViewEvent {
    const message = createBaseAloCategory_AloHandoffPageViewEvent();
    message.leadUuid = object.leadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.flipToken = object.flipToken ?? "";
    return message;
  },
};

function createBaseAloCategory_AloPageViewEvent(): AloCategory_AloPageViewEvent {
  return { leadUuid: "", offerUuid: "", flipToken: "", experienceSlug: 0 };
}

export const AloCategory_AloPageViewEvent = {
  fromJSON(object: any): AloCategory_AloPageViewEvent {
    return {
      leadUuid: isSet(object.leadUuid) ? String(object.leadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      flipToken: isSet(object.flipToken) ? String(object.flipToken) : "",
      experienceSlug: isSet(object.experienceSlug) ? aloCategory_ALOExperienceSlugFromJSON(object.experienceSlug) : 0,
    };
  },

  toJSON(message: AloCategory_AloPageViewEvent): unknown {
    const obj: any = {};
    if (message.leadUuid !== "") {
      obj.leadUuid = message.leadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.flipToken !== "") {
      obj.flipToken = message.flipToken;
    }
    if (message.experienceSlug !== 0) {
      obj.experienceSlug = aloCategory_ALOExperienceSlugToJSON(message.experienceSlug);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory_AloPageViewEvent>, I>>(base?: I): AloCategory_AloPageViewEvent {
    return AloCategory_AloPageViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory_AloPageViewEvent>, I>>(object: I): AloCategory_AloPageViewEvent {
    const message = createBaseAloCategory_AloPageViewEvent();
    message.leadUuid = object.leadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.flipToken = object.flipToken ?? "";
    message.experienceSlug = object.experienceSlug ?? 0;
    return message;
  },
};

function createBaseAloCategory_AloHandoffSubmitEvent(): AloCategory_AloHandoffSubmitEvent {
  return { leadUuid: "", offerUuid: "", flipToken: "", customerName: "", customerEmail: "", customerPhone: "" };
}

export const AloCategory_AloHandoffSubmitEvent = {
  fromJSON(object: any): AloCategory_AloHandoffSubmitEvent {
    return {
      leadUuid: isSet(object.leadUuid) ? String(object.leadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      flipToken: isSet(object.flipToken) ? String(object.flipToken) : "",
      customerName: isSet(object.customerName) ? String(object.customerName) : "",
      customerEmail: isSet(object.customerEmail) ? String(object.customerEmail) : "",
      customerPhone: isSet(object.customerPhone) ? String(object.customerPhone) : "",
    };
  },

  toJSON(message: AloCategory_AloHandoffSubmitEvent): unknown {
    const obj: any = {};
    if (message.leadUuid !== "") {
      obj.leadUuid = message.leadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.flipToken !== "") {
      obj.flipToken = message.flipToken;
    }
    if (message.customerName !== "") {
      obj.customerName = message.customerName;
    }
    if (message.customerEmail !== "") {
      obj.customerEmail = message.customerEmail;
    }
    if (message.customerPhone !== "") {
      obj.customerPhone = message.customerPhone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AloCategory_AloHandoffSubmitEvent>, I>>(
    base?: I,
  ): AloCategory_AloHandoffSubmitEvent {
    return AloCategory_AloHandoffSubmitEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AloCategory_AloHandoffSubmitEvent>, I>>(
    object: I,
  ): AloCategory_AloHandoffSubmitEvent {
    const message = createBaseAloCategory_AloHandoffSubmitEvent();
    message.leadUuid = object.leadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.flipToken = object.flipToken ?? "";
    message.customerName = object.customerName ?? "";
    message.customerEmail = object.customerEmail ?? "";
    message.customerPhone = object.customerPhone ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
